const actions = {
    QUICKLINKS_START: 'QUICKLINKS_START',
    QUICKLINKS_SUCCESS: 'QUICKLINKS_SUCCESS',
    QUICKLINKS_FAILURE: 'QUICKLINKS_FAILURE',


    NOTIFICATION_START: 'NOTIFICATION_START',
    NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
    NOTIFICATION_FAILURE: 'NOTIFICATION_FAILURE',

    EDIT_NOTIFICATION_START: 'EDIT_NOTIFICATION_START',
    EDIT_NOTIFICATION_SUCCESS: 'EDIT_NOTIFICATION_SUCCESS',
    EDIT_NOTIFICATION_FAILURE: 'EDIT_NOTIFICATION_FAILURE'
   
};

export default actions;